import { cn } from 'Utils/cn';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const sizeClasses = {
    small: 'size-8',
    default: 'size-12',
    extraSmall: 'size-3',
};

export default function Loading(props) {
    const { className, size = 'default' } = props;

    const { t } = useTranslation('common');

    const strokeWidth = size === 'small' ? 6 : 8;
    const sizeClass = sizeClasses[size];

    return (
        <div role="status" className="flex items-center justify-center">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="56"
                height="56"
                fill="none"
                viewBox="0 0 56 56"
                className={cn('inline animate-spin', sizeClass, className)}
            >
                <path
                    stroke="#E7E7EA"
                    opacity={0.25}
                    strokeWidth={strokeWidth}
                    d="M52 28a24 24 0 1 1-48 0 24 24 0 0 1 48 0Z"
                ></path>
                <path
                    stroke="url(#loading-gradient)"
                    strokeLinecap="round"
                    strokeWidth={strokeWidth}
                    d="M52 28a24 24 0 0 1-48 0"
                ></path>
                <defs>
                    <linearGradient
                        id="loading-gradient"
                        x1="28"
                        x2="56.5"
                        y1="52"
                        y2="16"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop stopColor="#A74EFF"></stop>
                        <stop offset="1" stopColor="#393992"></stop>
                    </linearGradient>
                </defs>
            </svg>
            <span className="sr-only">{t('loading')}</span>
        </div>
    );
}

Loading.propTypes = {
    className: PropTypes.string,
    size: PropTypes.oneOf(['small', 'default', 'extraSmall']),
};
